import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'lib-tooltip',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent {
  message = input<string>();
  iconAlt = input<string>();
  isWarning = input<boolean>(false);
}
